import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 상신문서 결재 반려
 * @param body
 * @returns {Promise<axios.AxiosResponse<any>>}
 * @constructor
 */
const vacationApprovalReject =(body)=>{
    return customAxios.post(myIpAddress+'/vacation/vacationApprovalReject', body);
}
export default vacationApprovalReject;